import React from 'react';
import Header from '../../Components/Header/Header';
import { FormattedMessage } from 'react-intl';
import './Footer.scss';

function Footer() {
    return (
        <div id="footerBlock" style={{ marginBottom: 60 }}>
            <footer className="footer d-flex align-items-center justify-content-center p-3">
                <FormattedMessage id="footer.copyright"></FormattedMessage>
            </footer>
            <div style={{ fontSize: '12px', marginBottom: '10px', textAlign: 'center' }}>
                This site is protected by reCAPTCHA and the <br />Google
              <a className="footer-privacy" style={{ marginLeft: '5px' }} href="https://policies.google.com/privacy">Privacy Policy</a> and
              <a className="footer-terms" style={{ marginLeft: '5px' }} href="https://policies.google.com/terms">Terms of Service</a> apply.
          </div>
        </div>
    )
}

export default Footer